var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.681 10.29h-0.4396c-0.6879 0-1.241-0.5731-1.241-1.286v-6.856c0-0.5196 0.3-0.9909 0.7655-1.189 0.4655-0.1982 0.9982-0.09106 1.355 0.2785l2.152 2.228c4.531-4.633 11.83-4.617 16.33 0.05356 4.526 4.687 4.526 12.28 0 16.97-4.526 4.687-11.86 4.687-16.39 0-0.6465-0.6695-0.6465-1.757 0-2.426 0.6465-0.6695 1.696-0.6695 2.343 0 3.233 3.348 8.472 3.348 11.7 0 3.233-3.348 3.233-8.774 0-12.12-3.217-3.332-8.415-3.348-11.65-0.05356l2.126 2.207c0.3569 0.3696 0.4603 0.9213 0.269 1.403-0.1914 0.4821-0.6465 0.7927-1.148 0.7927z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.d3b9f9f209ad8580bf49195adeab0033.svg";
export { ForwardRef as ReactComponent };